'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCurrentUrlFromState = exports.isServerSideRendered = exports.getPastUrl = exports.getCurrentUrl = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _reselect = require('reselect');

var _reactRouterRedux = require('react-router-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* reducer */
var DEFAULT_STATE = {
    currentUrl: {
        pathname: ''
    },
    pastUrl: {
        pathname: ''
    }
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _reactRouterRedux.LOCATION_CHANGE:
            return (0, _extends3.default)({}, state, {
                currentUrl: (0, _extends3.default)({}, action.payload),
                pastUrl: (0, _extends3.default)({}, state.currentUrl)
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.route;
};

var getCurrentUrl = exports.getCurrentUrl = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.currentUrl || {};
});

var getPastUrl = exports.getPastUrl = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.pastUrl || {};
});

var isServerSideRendered = exports.isServerSideRendered = (0, _reselect.createSelector)([getCurrentUrl, getPastUrl], function (currentUrl, pastUrl) {
    return pastUrl.pathname === currentUrl.pathname;
});

// This is state.routing because it uses the routing reducer from react-router-redux
var getCurrentUrlFromState = exports.getCurrentUrlFromState = function getCurrentUrlFromState(state, baseUrl) {
    return '' + baseUrl + state.routing.locationBeforeTransitions.pathname + state.routing.locationBeforeTransitions.search;
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/route.js
// module id = 9NGF
// module chunks = 57